'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  const navigationLinks = [
    { href: '/homepage', label: 'Accueil' },
    { href: '/services', label: 'Services' },
    { href: '/about', label: 'À propos' },
    { href: '/careers', label: 'Carrières' },
    { href: '/contact', label: 'Contact' },
  ];

  const toggleMobileMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-card shadow-md ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center space-x-2">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg overflow-hidden">
              <Image
                src="/assets/images/11958198-BEF2-462C-BE09-83DB57C854BC-1768765478440.png"
                alt="Services Rouissi Logo"
                width={40}
                height={40}
                className="object-contain"
              />
            </div>
            <span className="text-xl font-heading font-bold text-foreground">
              Services Rouissi
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationLinks.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-heading font-medium text-foreground hover:text-primary hover:bg-surface rounded-md transition-all duration-300 ease-out"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/quote-status"
              className="text-foreground hover:text-primary transition-colors font-heading font-medium"
            >
              Suivre mon devis
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-foreground hover:text-primary hover:bg-surface rounded-md transition-colors duration-300"
            aria-label="Toggle mobile menu"
          >
            <Icon
              name={isOpen ? 'XMarkIcon' : 'Bars3Icon'}
              size={24}
              variant="outline"
            />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="lg:hidden py-4 border-t border-border bg-card">
            <div className="flex flex-col space-y-1">
              {navigationLinks.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-3 text-sm font-heading font-medium text-foreground hover:text-primary hover:bg-surface rounded-md transition-all duration-300 ease-out"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;